module.exports = __webpack_public_path__ + "static/media/icon.e1c88d41.svg";